import Link from "next/link";
import Post from "../../../types/Post";
import styles from "./styles.module.scss";
import Image from "next/image";

interface ComponentTypes {
  items: Post;
}

export const AuthorComponent = ({ items }: ComponentTypes) => {
  return (
    <div>
      <p>Postagem escrita por:</p>
      <Link
        href={`author/${items.author.node.slug}`}
        passHref
        title={`Ver mais posts de ${items.author.node.name}`}
        rel="noreferrer"
        className={styles.articleAuthor}
      >
        {items.author.node.userAvatar?.userAvatar?.src && (
          <Image
            src={items.author.node?.userAvatar?.userAvatar?.src}
            className={styles.avatar}
            height={180}
            width={180}
            alt={`Foto do autor ${items.author.node?.name}`}
          />
        )}
        <div className={styles.authorInfo}>
          <h4 className={styles.authorName}>{items.author.node.name}</h4>
          <p className={styles.authorDescription}>
            {items.author.node.description}
          </p>
        </div>
      </Link>
    </div>
  );
};
